import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2-1h9a1 1 0 1 1 0 2H5V3ZM2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3-2h9a1 1 0 1 1 0 2H5V7Zm-3 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3-2h9a1 1 0 1 1 0 2H5v-2Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { BulletList16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var BulletList16 = createIcon(IconComponent);